var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenAccess = function SvgOpenAccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.284 15.115c-1.534 0-2.6-1.166-2.6-2.75 0-1.6 1.066-2.75 2.6-2.75 1.55 0 2.616 1.15 2.616 2.75 0 1.584-1.066 2.75-2.616 2.75m0-4.283c-.717 0-1.2.617-1.2 1.533 0 .917.483 1.534 1.2 1.534.716 0 1.216-.617 1.216-1.534 0-.933-.483-1.533-1.216-1.533M15.317 9.699l2.034 5.333h-1.417l-.383-1.033h-1.934l-.367 1.033h-1.383L13.9 9.699zm-1.283 3.15h1.1l-.55-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.333 5.067v14.666H4.667V5.067zM21 3.4H3v18h18z"
  })));
};
export default SvgOpenAccess;